/* Component Dependencies */
var hotelDescriptionTemplate = require('templates/hotelDescription.hbs');
var hotelDescriptionLiteTemplate = require('templates/hotelDescription-lite.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var Popup = require('libs/popup');

AriesComponent.create({
    type: 'hotelDescription',
    template: {
        'hotelDescription': hotelDescriptionTemplate,
        'hotelDescription-lite': hotelDescriptionLiteTemplate
    },
    events: {
        'click .js-show-more-toggle': 'toggleDescription'
    },
    bindEvents: function($) {
        var _self = this;
        $(window).on('load resize', function() {
            _self.handleDescriptionBlockDisplay();
        });
		_self.registerPopup();
    },
    /**
     * This function is used to restrict the display of description block to maximum 5 lines
     */
    handleDescriptionBlockDisplay: function() {
        var descriptionContainer,
            showMoreButton,
            maxHeight;

        descriptionContainer = this.$el.find('p');
        showMoreButton = this.$el.find('.js-show-more-toggle');
        maxHeight = parseInt(descriptionContainer.css('line-height')) * 5;
        showMoreButton.addClass('l-display-none');
        if (showMoreButton.data('is-more') === true) {
            descriptionContainer.removeClass('l-overflow-hidden t-collapsed-height');
            if (descriptionContainer.height() > maxHeight) {
                descriptionContainer.addClass('l-overflow-hidden t-collapsed-height');
            }
        }
        if (descriptionContainer.height() > maxHeight) {
            showMoreButton.removeClass('l-display-none');
        }
    },
    /**
     * This function is used to toggle the Description text on the click of showMore/showLess button
     * @param {Object} event Mouse event triggered on showMore/showLess click
     */
    toggleDescription: function(event) {
        event.preventDefault();
        var showMoreButton = $(event.currentTarget),
            descriptionContainer = this.$el.find('p');

        showMoreButton.data('is-more') ? showMoreButton.data('is-more', false).text(showMoreButton.data('show-less-label')) : showMoreButton.data('is-more', true).text(showMoreButton.data('show-more-label'));
      
        descriptionContainer.toggleClass('t-collapsed-height l-overflow-hidden');
    },
	/**
	* This function registers Popup for the points needed per night anchor
	*/
	 registerPopup: function() {
		 var _self= this;
		 var marriottRewardsPointsPopup = new Popup({
			 selector: '.js-open-popup',
			 sourceBlock: '.modal-content',
			 alternateCloseMarkup: true
		 });
		 marriottRewardsPointsPopup.register();
	 }
});